export const TOKEN_KEY = '@PEDIDOS_WEB';

export const isAuthenticated = () => window.localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => window.localStorage.getItem(TOKEN_KEY);

export const login = token => { window.localStorage.setItem(TOKEN_KEY, token)};

export const logout = () => { window.localStorage.removeItem(TOKEN_KEY)};